import clsx from 'clsx';
import styles from './Divider.module.scss';

export enum DividerDirection {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

interface DividerProps {
  direction?: DividerDirection;
  additionalClassName?: string;
}

const Divider = ({
  direction = DividerDirection.Horizontal,
  additionalClassName,
}: DividerProps) => {
  return <div className={clsx(styles.divider, styles[direction], additionalClassName)} />;
};

export default Divider;
